import type { CollectedDataOption } from '@onefootprint/request-types/dashboard';
import type { BusinessDataNodeProps } from '@/playbook-builder/playbook-builder.types';
import type { FormBusinessData } from '../business.types';

const createInfoPayload = (node: BusinessDataNodeProps, formData: FormBusinessData) => {
  const { successor: _, subject: __, ...data } = node.data;
  const includesBeneficialOwners = node.data.mustCollectData.includes('business_kyced_beneficial_owners');

  return {
    ...data,
    mustCollectData: [...createMustCollectData(formData, includesBeneficialOwners)],
  };
};

const createMustCollectData = (
  formData: FormBusinessData,
  shouldIncludeBeneficialOwners: boolean,
): Array<CollectedDataOption> => {
  const mustCollectData: Array<CollectedDataOption> = [];
  // Business name is always required
  mustCollectData.push('business_name');
  if (formData.address) {
    mustCollectData.push('business_address');
  }
  if (formData.corporationType) {
    mustCollectData.push('business_corporation_type');
  }
  if (formData.phone) {
    mustCollectData.push('business_phone_number');
  }
  if (formData.tin) {
    mustCollectData.push('business_tin');
  }
  if (formData.website) {
    mustCollectData.push('business_website');
  }
  if (shouldIncludeBeneficialOwners) {
    mustCollectData.push('business_kyced_beneficial_owners');
  }
  return mustCollectData;
};

export default createInfoPayload;
